const Flag = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2103_3391)">
            <path
                d="M10.2998 4.99998L10.6332 6.66665H14.9998V11.6666H12.1998L11.8665 9.99998H5.83317V4.99998H10.2998ZM11.6665 3.33331H4.1665V17.5H5.83317V11.6666H10.4998L10.8332 13.3333H16.6665V4.99998H11.9998L11.6665 3.33331Z"
                fill="#787878"
            />
        </g>
        <defs>
            <clipPath id="clip0_2103_3391">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
)
export default Flag
